export default __webpack_public_path__ + "static/banner-ece20ce49a4be707d522467a2df9cebd.png";